var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.taxonomy
    ? _c("span", [_vm._v("\n  Unknown\n")])
    : _vm.taxonomy.id === 0
    ? _c("span", [_vm._v("\n  " + _vm._s(_vm.taxonomy.name) + "\n")])
    : _vm.taxonomy.id <= 4000000
    ? _c(
        "a",
        {
          attrs: {
            href:
              "https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?mode=Info&id=" +
              _vm.taxonomy.id,
            title:
              "Taxonomic ID: " +
              _vm.taxonomy.id +
              " Rank: " +
              _vm.taxonomy.rank,
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.taxonomy.name) + "\n")]
      )
    : _c(
        "a",
        {
          attrs: {
            href:
              "https://gtdb.ecogenomic.org/searches?s=al&q=" +
              encodeURIComponent(_vm.taxonomy.name),
            title:
              "Taxonomic ID: " +
              _vm.taxonomy.id +
              " Rank: " +
              _vm.taxonomy.rank,
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.taxonomy.name) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }